// action - state management
import {
  LOGIN,
  LOGOUT,
  REGISTER,
  START_LOADING_AUTH,
  STOP_LOADING_AUTH,
} from "./actions";

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  loading: false,
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user,
      };
    }
    case LOGIN: {
      const { user } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
      };
    }

    case START_LOADING_AUTH:
      return {
        ...state,
        loading: true,
      };

    case STOP_LOADING_AUTH:
      return {
        ...state,
        loading: false,
      };

    default: {
      return { ...state };
    }
  }
};

export default accountReducer;
